import { useDispatch, useSelector } from 'react-redux';

export function useGeneralStore() {
	const dispatch = useDispatch();

	const backupDataTable = useSelector((state) => state.backupDataTable);
	const canalSegmentList = useSelector((state) => state.canalSegmentList);
	const commercialList = useSelector((state) => state.commercialList);
	const conditionsLists = useSelector((state) => state.conditionsLists);
	const coverageList = useSelector((state) => state.coverageList);
	const currencyList = useSelector((state) => state.currencyList);
	const dataTable = useSelector((state) => state.dataTable);
	const plansList = useSelector((state) => state.plansList);
	const suscriptor = useSelector((state) => state.suscriptor);
	const subscriberList = useSelector((state) => state.subscriberList);

	const setCurrencyList = (currencyList) =>
		dispatch({ type: 'SET_CURRENCY_LIST', payload: currencyList });

	const setConditionsLists = (conditionsLists) =>
		dispatch({ type: 'SET_CONDITIONS_LISTS', payload: conditionsLists });

	const setCoverageList = (coverageList) =>
		dispatch({ type: 'SET_COVERAGE_LIST', payload: coverageList });

	const setBackupDataTable = (dataTable) =>
		dispatch({ type: 'SET_BACKUP_DATA_TABLE', payload: dataTable });

	const setCanalSegmentList = (canalSegmentList) =>
		dispatch({ type: 'SET_CANAL_SEGMENT_LIST', payload: canalSegmentList });

	const setDataTable = (dataTable) =>
		dispatch({ type: 'SET_DATA_TABLE', payload: dataTable });

	const setSuscriptor = (suscriptor) =>
		dispatch({ type: 'SET_SUSCRIPTOR', payload: suscriptor });

	const setSubscriberList = (subscriberList) =>
		dispatch({ type: 'SET_SUBSCRIBER_LIST', payload: subscriberList });

	const setCommercialList = (commercialList) =>
		dispatch({ type: 'SET_COMMERCIAL_LIST', payload: commercialList });

	const setUpdateTable = (keyTable, data) =>
		dispatch({ type: 'SET_UPDATE_TABLE', payload: { keyTable, data } });

	const setPlansList = (plansList) =>
		dispatch({ type: 'SET_PLANS_LIST', payload: plansList });

	return {
		backupDataTable,
		canalSegmentList,
		commercialList,
		conditionsLists,
		coverageList,
		currencyList,
		dataTable,
		plansList,
		suscriptor,
		subscriberList,
		setCurrencyList,
		setConditionsLists,
		setCoverageList,
		setBackupDataTable,
		setCanalSegmentList,
		setDataTable,
		setSuscriptor,
		setSubscriberList,
		setCommercialList,
		setUpdateTable,
		setPlansList,
	};
}
